var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M90.5776 59.4239C95.7815 37.0137 81.8331 14.6279 59.423 9.42392C37.0126 4.21993 14.6269 18.1684 9.42294 40.5785C4.21895 62.9889 18.1674 85.3746 40.5776 90.5785C62.988 95.7826 85.3737 81.8343 90.5776 59.4239Z",
    fill: "#76A8E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M49.9993 6.43164C25.9358 6.43164 6.42773 25.9396 6.42773 50.0031C6.42773 74.0669 25.9358 93.5747 49.9993 93.5747C74.0629 93.5747 93.5709 74.0669 93.5709 50.0031C93.5709 25.9396 74.0638 6.43164 49.9993 6.43164ZM49.9993 91.6603C26.9931 91.6603 8.34306 73.0103 8.34306 50.004C8.34306 26.9978 26.9931 8.34784 49.9993 8.34784C73.0056 8.34784 91.6556 26.9987 91.6556 50.004C91.6565 73.0103 73.0065 91.6603 49.9993 91.6603Z",
    fill: "#569EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M49.9982 16.1689C31.3113 16.1689 16.1621 31.3181 16.1621 50.005C16.1621 68.6922 31.3113 83.8413 49.9982 83.8413C68.6854 83.8413 83.8345 68.6922 83.8345 50.005C83.8345 31.3181 68.6862 16.1689 49.9982 16.1689ZM49.9982 80.8047C32.9882 80.8047 19.1986 67.015 19.1986 50.0043C19.1986 32.9941 32.9882 19.2047 49.9982 19.2047C67.0082 19.2047 80.7987 32.9941 80.7987 50.0043C80.7987 67.015 67.0091 80.8047 49.9982 80.8047Z",
    fill: "#569EFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4824 56.1836C19.4824 56.1836 24.6301 80.4397 49.5906 80.4397C74.5519 80.4397 80.0519 56.1836 80.0519 56.1836C80.0519 56.1836 73.4946 79.5584 49.5906 79.0293C25.6874 78.5002 19.4824 56.1836 19.4824 56.1836Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M78.8683 54.7235C79.1549 53.0792 79.3051 51.3892 79.3051 49.6639C79.3051 33.4781 66.1843 20.3574 49.9988 20.3574C33.8131 20.3574 20.6924 33.4781 20.6924 49.6639C20.6924 51.6049 20.8831 53.5014 21.2431 55.3372C51.3004 59.0496 70.6383 56.4128 78.8683 54.7235Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.2874 53.8712C15.1631 52.6473 14.9042 50.8192 14.9284 49.5615C15.2874 30.6483 30.0058 14.8295 50.1628 14.9676C67.5974 15.0876 83.8376 27.7758 85.2739 48.9633C85.3671 50.3367 85.103 52.5342 84.9544 53.8712C87.2297 53.3905 89.7303 52.4142 90.274 51.798C90.3069 51.136 90.3233 50.4705 90.3233 49.7998C90.3233 27.5306 72.2335 10.2988 49.9642 10.2988C27.6951 10.2988 9.67871 27.5298 9.67871 49.7998C9.67871 50.4826 9.69598 51.1619 9.72964 51.836C11.5232 53.438 13.7191 53.3783 15.2874 53.8712Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5967 33.3192C11.5967 33.3192 20.9963 10.9965 40.6536 9.36426C22.5957 12.3119 11.5967 33.3192 11.5967 33.3192Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M90.5776 59.4239C95.7815 37.0137 81.8331 14.6279 59.423 9.42392C37.0126 4.21993 14.6269 18.1684 9.42294 40.5785C4.21895 62.9889 18.1674 85.3746 40.5776 90.5785C62.988 95.7826 85.3737 81.8343 90.5776 59.4239Z",
    fill: "#B8E6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_270_504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2861 64.2206V35.729C39.2861 33.4376 40.5524 32.1426 42.7926 32.1426H53.2635C60.5686 32.1426 66.0718 36.3765 66.0718 44.0474C66.0718 51.5688 60.5686 56.3506 52.8251 56.3506H46.3477V64.2206C46.3477 66.2131 44.7893 67.8569 42.8413 67.8569C40.8933 67.8569 39.2861 66.2131 39.2861 64.2206ZM46.3477 38.7176V49.7258H53.2635C56.5263 49.7258 59.0102 47.7831 59.0102 44.2465C59.0102 40.7101 56.5263 38.7176 53.2635 38.7176H46.3477Z",
    fill: "#3A5374"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_270_504",
    x: 39.2861,
    y: 32.1426,
    width: 26.7861,
    height: 36.2339,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.52
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_270_504"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_270_504",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokPoints);
export default __webpack_public_path__ + "static/media/tiktok_points.e31153fb4d8b64e3a4b117cc186e354a.svg";
export { ForwardRef as ReactComponent };